// const LoadJSON = require('../../../viscomjs/load/LoadJSON');
// const storage = require('../../../viscomjs/load/JSONStorage');
const data = require('../../../../../data/basic.json');

function ComponentLoad(id, progressUpdate) {
    return new Promise((resolve, reject) => {
        /* const json = storage.instance().getJSON(id);
        if (json) {
            resolve(json);
            return;
        }*/

        const doIt = func => {
            if (typeof progressUpdate !== 'undefined')
                progressUpdate({
                    progress: 100
                });
            resolve(func.default());
        };
        const err = () => {
            reject();
        };

        switch (data.sections[id].contentTemplate) {
            case 'Romanchuk':
                import(/* webpackPrefetch: true */ '../vue/components/stories/Romanchuk').then(doIt, err);
                break;

            case 'Leboshkin':
                import(/* webpackPrefetch: true */ '../vue/components/stories/Leboshkin').then(doIt, err);
                break;

            case 'Titov':
                import(/* webpackPrefetch: true */ '../vue/components/stories/Titov').then(doIt, err);
                break;

            case 'Korogorodskye':
                import(/* webpackPrefetch: true */ '../vue/components/stories/Korogorodskye').then(doIt, err);
                break;

            default:
                import(/* webpackPrefetch: true */ '../vue/components/stories/Sannikov').then(doIt, err);
                break;
        }


    });
}

module.exports = ComponentLoad;
